"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AcTableSelectorCell_module_scss_1 = __importDefault(require("./AcTableSelectorCell.module.scss"));
exports.AcTableSelectorCell = function (props) {
    var item = props.item, selected = props.selected, onSelect = props.onSelect;
    var onClick = function (e) {
        if (onSelect) {
            onSelect(item);
        }
    };
    var onChange = function () { };
    return (React.createElement("div", { style: { width: '15px' } },
        React.createElement("div", { className: "custom-control custom-checkbox " + AcTableSelectorCell_module_scss_1.default.checkDiv, onClick: onClick },
            React.createElement("input", { type: "checkbox", className: "custom-control-input", checked: selected, onChange: onChange }),
            React.createElement("label", { className: "custom-control-label " + AcTableSelectorCell_module_scss_1.default.checkLabel }))));
};
exports.AcTableSelectorCell.displayName = 'AcTableSelectorCell';
//# sourceMappingURL=AcTableSelectorCell.js.map